export type HostingType = "replo" | "shopify";

type ProjectLabels = {
  singular: string;
  plural: string;
  singularCapitalized: string;
  pluralCapitalized: string;
};

export const getProjectLabels = (hostingType?: HostingType): ProjectLabels => {
  if (hostingType === "replo") {
    return {
      singular: "site",
      plural: "sites",
      singularCapitalized: "Site",
      pluralCapitalized: "Sites",
    };
  }

  return {
    singular: "project",
    plural: "projects",
    singularCapitalized: "Project",
    pluralCapitalized: "Projects",
  };
};

type ProductLabels = {
  reploBuilder: string;
  shopifyThemeBuilder: string;
};

export const getProductLabels = (): ProductLabels => {
  return {
    reploBuilder: "Sites",
    shopifyThemeBuilder: "Shopify Theme Builder",
  };
};
